var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notification"},[(_vm.toastNotification)?_c('cv-toast-notification',{staticClass:"notification__toast",style:({
      '--border-color':
        _vm.toastNotification.kind === 'error' ? '#DA1E284D' : '#F1C21B4D',
    }),attrs:{"kind":_vm.toastNotification.kind,"title":_vm.toastNotification.title,"sub-title":_vm.toastNotification.subTitle,"caption":_vm.toastNotification.caption,"low-contrast":true,"hide-close-button":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }